/**
 * @generated SignedSource<<f28a6fec148280a5485288e085be8006>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ResolutionGroupHeader$data = {
  readonly displayName: string;
  readonly resolution: {
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ResolutionGroupHeader";
};
export type ResolutionGroupHeader$key = {
  readonly " $data"?: ResolutionGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"ResolutionGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ResolutionGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraJqlResolutionFieldValue"
};

(node as any).hash = "69c557634138dcd08dae628cc8eb1510";

export default node;
